import { styled } from '@mui/material/styles';

export type ChoiceTileCorner = 'small' | 'large' | 'round';
export type ChoiceGlyphCorner = 'none' | 'small' | 'round';

/** 32px option tile in a visual picker; the selected one is ringed and filled in the success color. */
export const ChoiceTile = styled('div', {
  shouldForwardProp: prop => prop !== 'selected' && prop !== 'corner',
})<{ selected: boolean; corner?: ChoiceTileCorner }>(({ theme, selected, corner = 'small' }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  cursor: 'pointer',
  borderRadius:
    corner === 'round' ? '50%' : Number(theme.shape.borderRadius) * (corner === 'large' ? 2 : 1),
  border: selected
    ? `3px solid ${theme.palette.success.main}`
    : `2px solid ${theme.palette.divider}`,
  backgroundColor: selected ? theme.palette.success.lighter : theme.palette.background.paper,
  '&:hover': { borderColor: theme.palette.success.main },
}));

/** 16px grey sample drawn inside a ChoiceTile to preview the option's shape. */
export const ChoiceGlyph = styled('div', {
  shouldForwardProp: prop => prop !== 'corner',
})<{ corner?: ChoiceGlyphCorner }>(({ theme, corner = 'none' }) => ({
  width: 16,
  height: 16,
  backgroundColor: theme.palette.grey[300],
  ...(corner === 'small' && { borderRadius: theme.shape.borderRadius }),
  ...(corner === 'round' && { borderRadius: '50%' }),
}));
